// Leaflet hero map for destination guides (port of DestinationMapHero.tsx).
import L from 'leaflet';

const ACCENT = '#00C2B0';

function airportMarkerHtml(code) {
  const pill = [
    'background:#0A1E38', 'color:#fff', 'padding:5px 10px', 'border-radius:8px',
    'border:1.5px solid rgba(0,194,176,0.35)', "font-family:'DM Sans',sans-serif",
    'font-size:11px', 'font-weight:700', 'line-height:1', 'white-space:nowrap',
    'box-shadow:0 4px 16px rgba(10,30,56,0.28)',
  ].join(';');
  return `<div style="${pill}">${code}</div>`;
}

export function initDestMapHero() {
  const el = document.getElementById('dest-map');
  if (!el || el.dataset.inited) return;
  let data;
  try {
    data = JSON.parse(el.getAttribute('data-dest-map'));
  } catch {
    return;
  }
  const { airport, city } = data;
  if (!airport || !city) return;
  el.dataset.inited = '1';

  const map = L.map(el, {
    zoomControl: false,
    scrollWheelZoom: false,
    dragging: false,
    doubleClickZoom: false,
    touchZoom: false,
    keyboard: false,
  });

  L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
    attribution: '© OpenStreetMap contributors © CARTO',
    maxZoom: 19,
  }).addTo(map);

  L.polyline(
    [[airport.lat, airport.lng], [city.lat, city.lng]],
    { color: ACCENT, weight: 3, dashArray: '9 7', opacity: 0.85 },
  ).addTo(map);

  const airportIcon = L.divIcon({
    className: 'dest-leaflet-marker',
    html: airportMarkerHtml(airport.code),
    iconAnchor: [22, 12],
  });
  const cityIcon = L.divIcon({
    className: 'dest-leaflet-marker',
    html: `<div style="width:14px;height:14px;border-radius:50%;background:${ACCENT};border:3px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,0.3);"></div>`,
    iconAnchor: [7, 7],
  });

  L.marker([airport.lat, airport.lng], { icon: airportIcon }).addTo(map);
  L.marker([city.lat, city.lng], { icon: cityIcon }).addTo(map);

  map.fitBounds(
    [[airport.lat, airport.lng], [city.lat, city.lng]],
    { padding: [80, 120] },
  );
}
